import { render, staticRenderFns } from "./BoardSettings.vue?vue&type=template&id=41f6e458&scoped=true&"
import script from "./BoardSettings.vue?vue&type=script&lang=js&"
export * from "./BoardSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f6e458",
  null
  
)

export default component.exports